import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { BareButton } from '@calendly/ui/components/bare-button';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const buttonCss = "bk6ws21";
const Button = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(buttonCss, props.className)} />);
const originallyAssignedContainerCss = "o1v58c04";
const OriginallyAssignedContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(originallyAssignedContainerCss, props.className)} />;
});
export const EventTypeHost = ({
  membership,
  isOriginallyAssigned,
  onClick
}) => <Button onClick={onClick} disabled={!membership.enabled || membership.is_pending}>
    <FullStoryExclude>
      <Avatar src={membership.avatar_url} letter={membership.avatar_letter} size="small" aria-hidden tabIndex={-1} />
    </FullStoryExclude>
    <div>
      <FullStoryMask>
        {membership.is_pending ? membership.email : membership.name}
      </FullStoryMask>
    </div>
    {isOriginallyAssigned && <OriginallyAssignedContainer>
          <BodyText color="muted" size="medium">
            {I18n.t('publisher.rescheduling_flow.host_picker_modal.originally_assigned')}
          </BodyText>
        </OriginallyAssignedContainer>}
  </Button>;

require("./event_type_host.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./event_type_host.js");